import React, { useEffect, useState } from 'react';

import { fetchImageUrl } from '../api/storage';
import { useAuthContext } from '../contexts/AuthContext';

interface DisplayImageProps {
  filePath: string;
  fileName: string;
  altText: string;
  round?: boolean;
  style?: React.CSSProperties;
  hide?: boolean;
}

const DisplayImage: React.FC<DisplayImageProps> = ({ fileName, filePath, altText, round, hide, style }) => {
  const { tenant } = useAuthContext();
  const [url, setUrl] = useState<string>();

  const tenantImagePath = `logos/${tenant}/image`; // assuming you store as "logos/<tenant>/image"

  const fetchUrl = async () => {
    // 1. Try primary image
    const primaryUrl = await fetchImageUrl(`${filePath}/${fileName}`);
    if (primaryUrl) {
      setUrl(primaryUrl);
      return;
    }
  };

  useEffect(() => {
    fetchUrl();
  }, [fileName, filePath, tenant]);

  return (
    <img
      src={url ?? 'missing.png'}
      alt={altText}
      style={
        url
          ? {
              ...style,
              borderRadius: round ? '50%' : '0%',
              aspectRatio: '1',
              objectFit: 'cover',
            }
          : {
              ...style,
              aspectRatio: '1',
              objectFit: 'cover',
            }
      }
    />
  );
};

export default DisplayImage;
